export default __webpack_public_path__ + "static/media/section-header-1.6f51ae2e.jpg";